import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {GroupedLessons, ScheduleTimeZone} from "features/model/types/groups/schedule/scheduleSchema";
import {fetchSchedule} from "features/model/service/groups/schedule/fetchSchedule";
import {toast} from "react-toastify";
import success = toast.success;
import {fetchScheduleDev} from "features/model/service/groups/schedule-dev/fetchScheduleDev";


interface ScheduleDevState {
    data: GroupedLessons;
    loading: boolean;
    error: string | null;
    hasToken:boolean;
    timeZones: ScheduleTimeZone[];
}

const initialState: ScheduleDevState = {
    data: {},
    loading: false,
    error: null,
    hasToken:false,
    timeZones: [],
};

const scheduleDevSlice = createSlice({
    name: "scheduleDev",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchScheduleDev.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchScheduleDev.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                state.data = action.payload.lessons;
                state.timeZones = action.payload.timeZones || [];
                state.hasToken = action.payload.hasToken
            })
            .addCase(fetchScheduleDev.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});


export const scheduleDevReducer = scheduleDevSlice.reducer;
